import React, { Component } from 'react';
import Des from '../Description/Des';

import Slider from '../Slider/Slider';

export default class Home extends Component {
    render() {
        return (
            <div>
            
            <Slider />
            <Des />
            </div>
        )
    }
}
